import { Trans } from 'react-i18next';
import { Box, Grid, Typography, Checkbox } from '@mui/material';

export default function StepShare({ t, partners, handleCheckboxChange }) {
  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2} alignItems="start">
        <Grid item xs={12} md={5}>
          <Typography component="h3" variant="h4" sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '42px' }, mt: 0 }}>
            {t('survey.create.stepper.title3')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography sx={{ display: 'block', mb: 1.2, fontSize: '23px', color: '#0d93d2', fontWeight: 700 }}>
            {t('survey.create.stepper.step3')}
          </Typography>
          <Typography sx={{ fontSize: '16px', fontWeight: 400, mb: 4 }}>
            <Trans i18nKey="survey.create.sharedResult" />
          </Typography>

          {partners.length > 0 && (
            <ul className="shareList" style={{ margin: 0, padding: 0, listStyle: 'none' }}>
              {partners
                .filter(p => p.id !== 'ADN')
                .map(partner => (
                  <li key={partner.id} style={{ marginBottom: 8 }}>
                    <Box
                      component="label"
                      htmlFor={`share-${partner.id}`}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        p: 1.5,
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: partner.checked ? '#58d7ff' : '#d9eaf4',
                        backgroundColor: partner.checked ? 'rgba(88,215,255,0.08)' : '#fff',
                        transition: 'all .15s ease',
                        cursor: 'pointer',
                        '&:hover': { borderColor: '#58d7ff' }
                      }}
                    >
                      <Checkbox
                        inputProps={{ id: `share-${partner.id}` }}
                        checked={partner.checked}
                        onChange={() => handleCheckboxChange(partner.id)}
                        sx={{
                          mr: 1.5,
                          mt: 0.25,
                          color: '#58d7ff',
                          '& .MuiSvgIcon-root': { fontSize: 18 },
                          '&.Mui-checked': { color: '#0d93d2' }
                        }}
                      />
                      <Box sx={{ flex: 1, opacity: partner.checked ? 1 : 0.6 }}>
                        <Typography component="span" sx={{ fontWeight: 700, display: 'block' }}>
                          {partner.name}
                        </Typography>
                        <Typography sx={{ mt: 0.25, fontSize: 14 }}>{partner.description || ''}</Typography>
                      </Box>
                    </Box>
                  </li>
                ))}
            </ul>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}